import { connect } from 'react-redux';

import DataForm from './DataForm.js';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const ConnectedDataForm = connect(
  mapStateToProps,
  null
)(DataForm);

export default ConnectedDataForm;
